// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFieldPropsSchemaForm.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import commonFieldPropsSchema from 'modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.ReportPartFieldPropsSchema';
import { get, unset, invokeArgs } from 'lodash/fp';

const UNUSED_PROPS = [
  'fields.dataFormattings.fields.alignment',
  'fields.dataFormattings.fields.verticalAlignment',
  'fields.dataFormattings.fields.columnWordWrap',
  'fields.headerFormating'
];

export default function(editorComp, reportDesignerModel, fieldStore, itemProps) {
  let formFieldPropsSchema = commonFieldPropsSchema.apply(null, arguments);

  const configField = itemProps.configField || {};

  // update schema
  formFieldPropsSchema.definedSchema = updateSchemaForForm(formFieldPropsSchema.definedSchema);

  updateSortProps(formFieldPropsSchema.definedSchema);

  return formFieldPropsSchema;

  /**
   * Remove unsed-properties
   * @param  {object} fieldSchema
   * @return {object}
   */
  function updateSchemaForForm(fieldSchema) {
    let newFieldSchema = fieldSchema;

    UNUSED_PROPS.forEach(pathItem => {
      newFieldSchema = unset(pathItem, newFieldSchema);
    });

    return newFieldSchema;
  }

  // TODO: remove this code.
  function updateSortProps(definedSchema) {
    let sortDef = get('fields.dataFormattings.fields.sort', definedSchema);
    const hasRepeaterPart = invokeArgs('getOtherProps', ['hasRepeaterPart'], configField.properties);

    sortDef.props.showInactiveState = !hasRepeaterPart;
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.ReportPartFieldPropsSchemaForm.js